"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlanContent = void 0;
const tslib_1 = require("tslib");
const utils_1 = require("./utils");
const tracker_1 = require("./utils/tracker");
/**
 * This function fetches the Plans content from Contentful based on the provided planSocs.
 * @param {
 * space: string,
 * accessToken: string,
 * environment: string,
 * host: string,
 * locale: string,
 * trackingApplicationName: string,
 * planSocs: string | string[]}
 * @returns an object indexed by the plan socs => {'SOC1:{...}', 'SOC2:{...}', ...}
 */
const getPlanContent = async ({ space, accessToken, environment, host, locale, trackingApplicationName, planSocs }) => {
    const client = (0, utils_1.getClient)({ space, accessToken, host, environment });
    const searchString = typeof planSocs === 'string' ? planSocs : planSocs === null || planSocs === void 0 ? void 0 : planSocs.map((plan) => `${plan}`).join(',');
    const content = await client
        .getEntries({
        content_type: 'plans',
        locale,
        limit: 1000,
        include: 5,
        'fields.soc[in]': searchString
    })
        .catch((error) => {
        throw new Error(`Error fetching Plan content, ${error}`);
    });
    const mappedPlans = content.items.reduce((acc, plan) => {
        // eslint-disable-next-line no-unused-vars
        const _a = plan.fields, { entryTitle, planSoc } = _a, rest = tslib_1.__rest(_a, ["entryTitle", "planSoc"]);
        if (rest === null || rest === void 0 ? void 0 : rest.soc)
            acc[rest.soc] = (0, utils_1.removeSysKey)((0, utils_1.transformObjectToRemoveFields)(rest));
        return acc;
    }, {});
    void (0, tracker_1.trackData)(content, trackingApplicationName, space !== null && space !== void 0 ? space : '');
    return mappedPlans;
};
exports.getPlanContent = getPlanContent;
//# sourceMappingURL=getPlanContent.js.map